import { helper } from '@ember/component/helper';

/**
 * Whether given params are something other than false or 'false'
 * Note: returns true for both truthy and falsy values other than false or
 * 'false' (e.g. undefined, null, 0, true, 'string').
 * @see is-true
 * @param {*[]} params
 * @return {boolean}
 */
export default helper(function notFalseHelper(params) {
  return params.every(v => v !== false && v !== 'false');
});
